import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import { UiSlider } from "../../components/common/UiSlider";
import UiContentCard from "../../components/cards/UiContentCard"
import Nike from "../../../../styles/img/favourites/nike.jpg"
import SliderHeart from "../../../../styles/img/slider-heart-icon.png";
import { UiNextArrow, UiPrevArrow } from "../../components/common/UiSliderArrows.jsx";
import Rewards from "../../../../styles/img/rewards-icon.png"
import Earn from "../../../../styles/img/earn-icon.png"
import { UiTopBgSlider, UiTopBgSliderLeftContent } from "../../components/common/UiTopBgSliderElements"


export default function HomeSlider(props) {

    const UiMainSlider = {
        dots: props.dots,
        infinite: true,
        speed: 500,
        slidesToShow: props.slidesToShow,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                }
            }]

    };
    const learnMore = () => {
    }

    return (
        <>
            <UiTopBgSlider>
                <UiCol lg="7">
                    <UiTopBgSliderLeftContent>
                        <p className='sb-top-bg-slider__slider-content__top-content'>Lorem Ipsum 432 </p>
                        <h2>The Way To Add
                            More Zing To
                            Your Work <img src={SliderHeart} /></h2>
                        <p className='sb-top-bg-slider__slider-content__description'>
                            You’re already working hard, enjoy the benefits of
                            various rewards you, your team and your family can enjoy.</p>
                    </UiTopBgSliderLeftContent>

                </UiCol>
                <UiCol lg="5" className="mt-3">

                    <UiSlider UiSliderSettings={UiMainSlider}>
                        <div className="sb-top-bg-slider__slider-wrapper">
                            <UiRowContainer>
                                <UiCol lg="12">
                                    <UiContentCard
                                        cardImg={Nike}
                                        rating="4.41"
                                        reviews="47"
                                        flashImage={Earn}
                                        flashText="Earn Now!"
                                        heading="Manchester"
                                        msgStatus="Earn"
                                        body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."

                                    />
                                </UiCol>
                            </UiRowContainer>
                        </div>
                        <div>
                            <UiRowContainer>
                                <UiCol lg="12">
                                    <UiContentCard
                                        cardImg={Nike}
                                        rating="4.41"
                                        reviews="47"
                                        heading="Manchester"
                                        msgStatus="Rewards"
                                        flashImage={Rewards}
                                        flashText="Spend Now!"
                                        body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."

                                    />
                                </UiCol>
                            </UiRowContainer>
                        </div>
                        <div>
                            <UiRowContainer>
                                <UiCol lg="12">
                                    <UiContentCard
                                        cardImg={Nike}
                                        rating="4.41"
                                        reviews="47"
                                        flashImage={Earn}
                                        flashText="Earn Now!"
                                        heading="Manchester"
                                        msgStatus="Earn"
                                        body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."

                                    />
                                </UiCol>
                            </UiRowContainer>
                        </div>
                    </UiSlider>
                </UiCol>

            </UiTopBgSlider>
        </>
    )
}
